"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _excluded = ["x"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var x = props.x,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({}, rest, {
    viewBox: '0 0 17 17',
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", Object.assign({}, x ? {
    style: {
      transformOrigin: '50%',
      transform: 'rotate(37deg) translateX(7.5px) scaleY(1.1)'
    }
  } : {}, {
    d: "M2.5,16 C2.224,16 2,15.776 2,15.5 L2,7.44733333 C0.848666667,7.21066667 0.00333333333,6.196 0,5.00133333 L0,0.5 C0,0.224 0.224,0 0.5,0 C0.776,0 1,0.224 1,0.5 L1,5 C1.002,5.63666667 1.41533333,6.19933333 2,6.41 L2,0.5 C2,0.224 2.224,0 2.5,0 C2.776,0 3,0.224 3,0.5 L3,6.41 C3.58466667,6.19933333 3.998,5.63666667 4,4.99866667 L4,0.5 C4,0.224 4.224,0 4.5,0 C4.776,0 5,0.224 5,0.5 L5,5 C4.99666667,6.196 4.15133333,7.21133333 3,7.44733333 L3,15.5 C3,15.776 2.776,16 2.5,16 Z",
    id: "Path"
  })), /*#__PURE__*/_react["default"].createElement("path", Object.assign({}, x ? {
    style: {
      transformOrigin: '50%',
      transform: 'rotate(-37deg) translateX(-2.5px) scaleY(1.1)'
    }
  } : {}, {
    d: "M9.5,16 C9.224,16 9,15.776 9,15.5 L9,7.5 L8.83333333,7.5 C7.82266667,7.5 7,6.67733333 7,5.66666667 L7,1.83333333 C7,0.822666667 7.82266667,0 8.83333333,0 L10.1666667,0 C11.1773333,0 12,0.822666667 12,1.83333333 L12,5.66666667 C12,6.67733333 11.1773333,7.5 10.1666667,7.5 L10,7.5 L10,15.5 C10,15.776 9.776,16 9.5,16 Z M8.83333333,1 C8.374,1 8,1.374 8,1.83333333 L8,5.66666667 C8,6.126 8.374,6.5 8.83333333,6.5 L10.1666667,6.5 C10.626,6.5 11,6.126 11,5.66666667 L11,1.83333333 C11,1.374 10.626,1 10.1666667,1 L8.83333333,1 Z",
    id: "Shape"
  })));
});